import React from 'react'
import PropTypes from "prop-types";
import entete from "../../../assets/img/entete.jpg"
import footer from "../../../assets/img/footer.png";
import { frenchDateOnly } from '../../../variables/functions';
import { Table } from 'antd';
import { displayNumbers } from '../../../variables/numbersFunctions';
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import DocumentHeader from '../../../components/docs/DocumentHeader';

const BorderauCommissions = React.forwardRef((props, ref) => {
    const MyFooter = () => {
        return (
            <>
                <div>
                    <b>Total commissions</b>:{" "}
                    {displayNumbers(props?.bordereau?.montantTotal)} F CFA
                </div>
            </>
        );
    };

    const columns = [
        {
            title: "Police",
            dataIndex: "numeroPoliceP",
            key: "numeroPoliceP",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.contrat?.numeroPoliceM ? record.contrat?.numeroPoliceM : record.contrat?.numeroPoliceP}</p>
            ),
            width: 100
        },
        // {
        //     title: "Avenant",
        //     dataIndex: "numeroPoliceP",
        //     key: "numeroPoliceP",
        //     render: (_, record) => (
        //         <p style={{ width: "100%" }}>{record.avenant?.code}</p>
        //     ),
        //     width: 15
        // },
        {
            title: "Assuré",
            dataIndex: "assure",
            key: "assure",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.contrat?.souscripteur?.nom} {record.contrat?.souscripteur?.prenom}</p>
            ),
            width: 150
        },
        {
            title: "Effet",
            dataIndex: "dateEffet",
            key: "dateEffet",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record?.contrat?.dateEffet ? frenchDateOnly(record?.contrat?.dateEffet) : "-"} </p>
            ),
            width: 50
        },

        {
            title: "Echéance",
            dataIndex: "dateEcheance",
            key: "dateEcheance",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record?.contrat?.dateEcheance ? frenchDateOnly(record?.contrat?.dateEcheance) : "-"} </p>
            ),
            width: 50
        },
        {
            title: "Catégorie",
            dataIndex: "categorie",
            key: "categorie",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.contrat?.categorie}</p>
            ),
            width: 30
        },
        {
            title: "PN Pool",
            dataIndex: "primeNette",
            key: "primeNette",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.montant)} </p>
            ),
            width: 80
        },
        // {
        //     title: "PN Cie",
        //     dataIndex: "primeNette",
        //     key: "primeNette",
        //     render: (_, record) => (
        //         <p style={{ width: "100%" }}>{displayNumbers(record.montant)} </p>
        //     ),
        //     width: 80
        // },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
            render: (_, record) => (
                <p style={{ width: "50%" }}>{displayNumbers(record?.accessoires)} </p>
            ),
            width: 10
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.taxes)} </p>
            ),
            width: 10
        },
        {
            title: "Taux de commission",
            dataIndex: "tauxCommissions",
            key: "tauxCommissions",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.tauxCommission)} </p>
            ),
            width: 10
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "commission",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.commission)} </p>
            ),
            width: 90
        },
        {
            title: "Retenue/C",
            dataIndex: "retenue",
            key: "retenue",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.retenue || 0)} </p>
            ),
            width: 10
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "commission",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers((record.commission * record.retenue) || 0)} </p>
            ),
            width: 90
        },
    ];


    return (
        <div ref={ref}>
            <div class="row">
                <div class="col-12">
                    <div className="page-2">
                        <DocumentHeader logoPreviewUrl={`data:image/png;base64,${props?.bordereau?.logoDisplay}`} />
                        <div class="card testimonial-card" style={{ width: "1155px" }}>
                            <div class="text-center">
                                <h5><u>Bordereau de commissions N° {props?.bordereau?.numeroBordereau}</u></h5>
                            </div>
                            <div class="row">
                                <div className="col-lg-12">
                                    {/* <div className="container"> */}
                                    <Table
                                        style={{ width: "1155px" }}
                                        columns={columns}
                                        dataSource={props?.bordereau?.reglements}
                                        pagination={false}
                                        size='small'
                                        bordered
                                        className="custom-table"
                                        footer={() => <MyFooter />}
                                    />
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                        <DocumentFooter />
                    </div>

                </div>
            </div>
        </div>
    )
});
BorderauCommissions.propTypes = {
    bordereau: PropTypes.object,
    agence: PropTypes.object,
}
export default BorderauCommissions